import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import updateTargetings from './update-targetings';
import { IMAGE } from '../../constants';
import { PB_TYPE_BANNER } from './constants';
const checkCollision = (typeToCheck, currentType) => {
  if (currentType === IMAGE) return true;
  return typeToCheck === IMAGE;
};
const injectElementComponents = (componentsToInject, children) => {
  if (!componentsToInject.length) return children;
  const updatedChildren = [];
  componentsToInject.forEach(componentToInject => {
    const {
      type: componentsToInjectType,
      settings: {
        repeatEvery,
        startingPoint,
        maxRepetitions
      }
    } = componentToInject;
    let repetitionTotal = 0;
    let currentPosition = startingPoint;
    children.forEach((child, i) => {
      const isComponentMatch = componentToInject.name !== child.name;
      const {
        type
      } = child;
      const {
        type: previousComponentType
      } = children[i - 1] || {};
      const {
        type: nextComponentType
      } = children[i + 1] || {};
      const collidedBefore = checkCollision(previousComponentType, type);
      const collidedAfter = checkCollision(nextComponentType, type);
      if (collidedBefore || i === 0 && collidedAfter) {
        if (currentPosition <= i) currentPosition += 1;
        if (isComponentMatch) updatedChildren.push(child);
        return;
      }
      const hasReachedMax = maxRepetitions && repetitionTotal >= maxRepetitions;
      if (!hasReachedMax && i === currentPosition) {
        const updatedComponentToInject = repeatEvery && componentsToInjectType === PB_TYPE_BANNER ? updateTargetings(componentToInject, repetitionTotal) : componentToInject;
        const updatedSettings = _objectSpread({}, updatedComponentToInject.settings);
        updatedChildren.push(_objectSpread(_objectSpread({}, updatedComponentToInject), {}, {
          settings: updatedSettings
        }));
        repetitionTotal += 1;
        currentPosition += repeatEvery;
      }
      if (isComponentMatch) updatedChildren.push(child);
    });
  });
  return updatedChildren;
};
export default injectElementComponents;
//# sourceMappingURL=inject-element-components.js.map